'use client';
import { useContext, useEffect, useState } from 'react';
import styles from './login.module.scss';
import { __PhoneType } from './login.type';
import OtpFormComp from './otpForm/otpForm.index';
import PhoneFormComp from './phoneForm/phoneForm.index';
import { AppStorage, RestAPI } from 'scripts';
import { API } from 'data';
import { AppContextActionKeyEnum } from 'types';
import { GlobalContext } from 'context';

function LoginComp() {
    const [phone, setPhone] = useState<__PhoneType>(null);
    const { update } = useContext(GlobalContext);
    useEffect(() => {
        RestAPI.post(API.middlewares.logout, {}).then(() => {
            update({ key: AppContextActionKeyEnum.profile, value: undefined });
            AppStorage.authToken.remove();
        });
    }, []);
    return (
        <div className={`${styles['login-layout']} center-content h-100 flex-column`}>
            {phone === null ? <PhoneFormComp setPhone={setPhone} /> : <OtpFormComp setPhone={setPhone} phone={phone} />}
        </div>
    );
}

export default LoginComp;
